const state = {
  disaster: {}
};

const getters = {
  disaster(state) {
    return state.disaster;
  }
};

const mutations = {
  setDisaster(state, disaster) {
    state.disaster = disaster;
  },
  clearDisaster(state) {
    state.disaster = {};
  }
};

const actions = {
  setDisaster(context, disaster) {
    context.commit("setDisaster", disaster);
  },
  clearDisaster(context) {
    context.commit("clearDisaster");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
